import React from 'react';
import { FiX, FiLayers, FiStar } from 'react-icons/fi';
import styles from './Emitir.module.css';
import useEsc from '../../../hooks/useEsc';

/* Escolha do perfil de tributação. Mesmo padrão do tomador: a tela de
   emissão mostra só o resultado, a escolha acontece aqui.

   Quem tem um perfil só nunca vê este modal -- ele é aplicado sozinho. */

function resumoCodigos(p) {
  return [
    p.codigo_tributacao_nacional && `CTN ${p.codigo_tributacao_nacional}`,
    p.item_nbs && `NBS ${p.item_nbs}`,
    p.codigo_operacao && `oper. ${p.codigo_operacao}`,
    p.aliquota_iss != null && p.aliquota_iss !== '' && `ISS ${p.aliquota_iss}%`,
    p.reter_iss && 'retém ISS',
  ].filter(Boolean).join(' · ') || 'sem códigos definidos';
}

function ModalPerfis({ perfis, perfilId, onFechar, onSelecionar }) {
  useEsc(onFechar);
  return (
    <div className={styles.modalFundo}>
      <div className={styles.modalCaixa} style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
        <div className={styles.modalTopo}>
          <div>
            <h3 className={styles.modalTitulo}>Perfil de tributação</h3>
            <p className={styles.modalSub}>
              Os códigos da nota vêm do perfil. Cadastre em Clientes › Parâmetros de NF.
            </p>
          </div>
          <button type="button" className={styles.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>

        <div className={styles.modalLista} style={{ paddingTop: 12 }}>
          {perfis.map(p => (
            <button key={p.id} type="button"
              className={`${styles.tomadorItem} ${p.id === perfilId ? styles.tomadorItemAtivo : ''}`}
              onClick={() => onSelecionar(p)}>
              <span className={styles.tomadorIcone}><FiLayers size={13} /></span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className={styles.tomadorNome}>
                  {p.nome}
                  {p.padrao && <FiStar size={10} color="#f59e0b" style={{ marginLeft: 5 }} />}
                </span>
                <span className={styles.tomadorDoc}>{resumoCodigos(p)}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ModalPerfis;
